import type { Row } from '../../../../components/FileReader';

export type PhoneTableProps = {
  rows: Row[] | null;
};

export const PhoneTable: React.FC<PhoneTableProps> = ({ rows = [] }) => {
  return (
    <table className="min-w-full table-auto border border-gray-300">
      <thead>
        <tr>
          {rows &&
            rows?.length > 0 &&
            Object.keys(rows?.[0])
              .slice(0, 3)
              .map((key, idx) => (
                <th key={idx} className="border p-2 bg-gray-100">
                  {key}
                </th>
              ))}
        </tr>
      </thead>
      <tbody>
        {rows?.map((row, i) => (
          <tr key={i}>
            {Object.values(row)
              .slice(0, 3)
              .map((value, idx) => (
                <td key={idx} className="border p-2">
                  {value as string}
                </td>
              ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
